const server =
  import.meta.env.MODE === 'development'
    ? 'http://localhost:3000'
    : 'https://community-decarbonisation-api.app.kinesis.org';

export { server };
